//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { redux_store } from "../../../store";
import { API } from "../../api";
async function order_list(query) {
    const { userState } = redux_store.getState();
    const { user } = userState;
    const url = process.env.LETS_TRADE_ORDER_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/order/list${objectToQueryString({
            ...query,
            user_id: user?.user?._id,
        })}`,
    });
}
export { order_list };
